export const API_URL = 'https://nucleus-api.stg.videahealth.io';
export const CONNECTOR_API_URL = 'https://connector.stg.videahealth.io';
export const PARSE_APPLICATION_ID =
  'DwjY3wpxaUUR2Ehd4acfuRATcHuei7sPr4aHhUUjGB';
export const NETWORK_REQUEST_TIMEOUT_IN_MILLIS = 60000;
export const VIDEA_BEACON_URL = 'ws://localhost:8090/Watcher';
export const BUILD_CONFIGURATION = 'NON_FDA';
export const SHOW_VALIDATION_DROP_DOWN_MENUS = false;
export const MIXPANEL_TOKEN = '4f6dfb9a2009229a43d9574bb1121c55';
export const USERPILOT_TOKEN = 'STG-NX-2caf528a';
export const LANGFUSE_PUBLIC_KEY = 'pk-lf-0fa6a25f-be63-471c-be60-47f5e06038f3';
export const LANGFUSE_NOTES_PUBLIC_KEY = 'pk-lf-df815ec6-e76b-4341-b433-16454b1075c9';
export const LANGFUSE_BASE_URL = 'https://langfuse.synapse.dev.videahealth.io';
export const OKTA_DOMAIN = 'https://login.stg.videahealth.io';
export const OKTA_CLIENT_ID = '0oaq1kjcd9Pfs0KuF5d7';
export const SENTRY_ENABLED = true;
export const DEX_CONVERSION_API_URL = 'https://dex-api.stg.videahealth.io';
export const OPS_DASHBOARD_SHOW_WATCHLIST = false;
export const AIRTABLE_API_KEY =
  'patigtWu02gTD7Swh.d508708a2c5a9d5721564b0896d2ae184f3a64dde46ad3d4852c58ef161955c6';
export const AIRTABLE_BASE_ID = 'appoQ9I2TU8c6DDkj';

// Keycloak / Synapse authentication
// TODO: Staging synapse not deployed yet - using dev for now
export const AMBIENT_API_URL = 'https://ambient.api.synapse.dev.videahealth.io';
export const KEYCLOAK_URL = 'https://keycloak.api.synapse.dev.videahealth.io';
export const KEYCLOAK_REALM = 'synapse';
export const KEYCLOAK_CLIENT_ID = 'synapse-spa';
export const SYNAPSE_TOKEN_URL = 'https://token.external.synapse.dev.videahealth.io';
